module.exports = __webpack_public_path__ + "ba0b9a7fb600075fb7bcdc6872aacc43.pdf";